import { message } from "antd";

export function isHasBasicInfo () {
    let token = localStorage.getItem('accessToken');
    let orgId = localStorage.getItem('orgId');
    let routeKey = localStorage.getItem('routeKey') || '';
    if(!token || !orgId || !routeKey) {
        return false;
    }
    else {
        return true;
    }
}

export enum AccountType {
    MOBILENUMBER = "MOBILENUMBER",
    EMAIL = "EMAIL"
}

export function verifyTelcodeOrEmail (value) {
    // 校验电话格式
    let regTelcode = /^((13[0-9])|(14[5-9])|(15([0-3]|[5-9]))|(16[6-7])|(17[1-8])|(18[0-9])|(19[1|3])|(19[5|6])|(19[8|9]))\d{8}$$/;
    let isTelCode = regTelcode.test(value);
    let isEmail = false;
    let type = AccountType.MOBILENUMBER;
    if(!isTelCode) {
        // 校验邮箱格式
        let reg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
        isEmail = reg.test(value);
        type = AccountType.EMAIL;
    }
    if(!isTelCode && !isEmail) {
        message.error('账号格式错误', 6);
        return {
            valid: false,
            type,
        }
    }
    else {
        return {
            vaild: true,
            type
        }

    }
}